<template>
  <div class="projects container-fluid">
    <div class="col-10 text">
      <p>
        Z myślą o wszystkich, którzy są zainteresowani ostatecznym efektem
        wizualnym, jaki gwarantują nasze rozwiązania przygotowaliśmy portfolio.
        Zamieściliśmy w nim przykładowe projekty wykonane z użyciem desek litych
        i warstwowych. Realizacje doskonale pokazują jak prezentują się gotowe
        podłogi w różnego rodzaju pomieszczeniach. Przedstawiliśmy na zdjęciach
        kilka różnych wariantów – o odmiennej kolorystyce i wykończeniu
        nawierzchni. Zależało nam na pokazaniu złożoności oferty, a także
        przekonaniu Państwa – jeśli jeszcze się wahacie – do wyboru konkretnego
        modelu. Zdjęcia przedstawiają stan faktyczny. Oznacza to, że taki sam
        lub bardzo zbliżony efekt jesteśmy w stanie osiągnąć także w Państwa
        domach. Nasze produkty bardzo dobrze nadają się także do prestiżowych
        biurowców i ekskluzywnych hoteli.
      </p>
    </div>
    <!-- <div
      v-scrollanimation
      class="image col-10 col-sm-5 col-md-4 col-xl-3 anim"
      v-for="(image, index) in media"
      :key="index"
      @click="openGallery(index)"
      :style="{
        width: 'auto',
        height: '17rem'
      }"
    > -->
    <div
      v-scrollanimation
      class="image col-10 col-sm-5 col-md-4 col-xl-3 anim"
      v-for="(image, index) in media"
      :key="index"
      @click="openGallery(index)"
      :style="{
        width: 'auto',
        height: '17rem'
      }"
    >
      <img v-lazy="image.thumb" @click="openGallery(index)" />
      <h3>{{ image.description }}</h3>
    </div>

    <LightBox
      ref="lightbox"
      :media="media"
      :show-caption="true"
      :show-light-box="false"
    />
  </div>
</template>

<script>
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import projectImages from "./projectImages.js";
import LightBox from "vue-image-lightbox";
export default {
  data: function() {
    return {
      index: null,
      media: projectImages
    };
  },
  methods: {
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    }
  },

  components: {
    LightBox
  }
};
</script>
<style scoped>
.text {
  text-align: center;
  margin-top: 2%;
}
.projects {
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.image {
  height: auto;
  display: inline-block;
  position: relative;
  transition: 0.3s;
  margin: 1%;
  overflow: hidden;
}

.image img {
  width: 100%;
  height: 100%;
  transition: 0.3s;
  border-radius: 4px;
}

.image:hover img {
  filter: blur(2px) brightness(60%);
  /* box-shadow: 0 0 16px rgb(32, 28, 28); */
  cursor: pointer;
}

.image :not(img) {
  position: absolute;
  z-index: 1;
  width: 90%;
  top: 50%;
  left: 5%;
  color: #fff;
  opacity: 0;
  transition: 0.3s;
}

.image:hover :not(img) {
  cursor: pointer;
  opacity: 1;
}
</style>
